export const AppRoutes = {
  Login: '/login',
  Classication: '/classification'
}
